"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
enum SubmissionStatus {
  NOT_STARTED = "NOT_STARTED",
  ACTIVE = "ACTIVE",
  ENDED = "ENDED",
}
export enum SubmissionRestriction {
  NOT_LOGGED_IN = "NOT_LOGGED_IN",
  PROXY_USER = "PROXY_USER",
  NO_PERMISSION = "NO_PERMISSION",
  NOT_STARTED = "NOT_STARTED",
  ENDED = "ENDED",
  MAX_DROPS_REACHED = "MAX_DROPS_REACHED",
}
export enum ChatRestriction {
  NOT_LOGGED_IN = "NOT_LOGGED_IN",
  PROXY_USER = "PROXY_USER",
  NO_PERMISSION = "NO_PERMISSION",
  DISABLED = "DISABLED",
}
interface DropPrivilegesInput {
  readonly isLoggedIn: boolean;
  readonly isProxy: boolean;
  readonly canChat: boolean;
  readonly canDrop: boolean;
  readonly chatDisabled: boolean;
  readonly submissionStarts: number | null;
  readonly submissionEnds: number | null;
  readonly maxDropsCount: number | null;
  readonly identityDropsCount: number | null;
}
export interface DropPrivileges {
  readonly submissionRestriction: SubmissionRestriction | null;
  readonly chatRestriction: ChatRestriction | null;
}
export function useDropPrivileges(t0) {
  const $ = _c(3);
  const {
    isLoggedIn,
    isProxy,
    canChat,
    canDrop,
    chatDisabled,
    submissionStarts,
    submissionEnds,
    maxDropsCount,
    identityDropsCount
  } = t0;
  const now = Date.now();
  let submissionStatus;
  if (submissionStarts === null && submissionEnds === null) {
    submissionStatus = SubmissionStatus.ACTIVE;
  } else {
    if (submissionStarts === null && submissionEnds !== null) {
      submissionStatus = now <= submissionEnds ? SubmissionStatus.ACTIVE : SubmissionStatus.ENDED;
    } else {
      if (submissionEnds === null && submissionStarts !== null) {
        submissionStatus = now < submissionStarts ? SubmissionStatus.NOT_STARTED : SubmissionStatus.ACTIVE;
      } else {
        if (submissionStarts !== null && submissionEnds !== null) {
          if (now < submissionStarts) {
            submissionStatus = SubmissionStatus.NOT_STARTED;
          } else {
            if (now > submissionEnds) {
              submissionStatus = SubmissionStatus.ENDED;
            } else {
              submissionStatus = SubmissionStatus.ACTIVE;
            }
          }
        } else {
          submissionStatus = SubmissionStatus.NOT_STARTED;
        }
      }
    }
  }
  const t1 = !isLoggedIn ? SubmissionRestriction.NOT_LOGGED_IN : isProxy ? SubmissionRestriction.PROXY_USER : !canDrop ? SubmissionRestriction.NO_PERMISSION : maxDropsCount !== null && identityDropsCount !== null && identityDropsCount >= maxDropsCount ? SubmissionRestriction.MAX_DROPS_REACHED : submissionStatus !== SubmissionStatus.ACTIVE ? submissionStatus === SubmissionStatus.NOT_STARTED ? SubmissionRestriction.NOT_STARTED : SubmissionRestriction.ENDED : null;
  const t2 = !isLoggedIn ? ChatRestriction.NOT_LOGGED_IN : isProxy ? ChatRestriction.PROXY_USER : !canChat ? ChatRestriction.NO_PERMISSION : chatDisabled ? ChatRestriction.DISABLED : null;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      submissionRestriction: t1,
      chatRestriction: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}